const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7×24小时全天候监控全网热点，第一时间推送911吃瓜黑料最新事件，确保你永远快人一步。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量合集',
    desc: '精心整理911爆料吃瓜黑料合集，按主题、人物、事件分类归档，方便一站式浏览回顾。',
  },
  {
    icon: 'ri-vidicon-line',
    title: '视频吃瓜',
    desc: '聚合全网911吃瓜黑料视频内容，支持高清播放，让你直观感受每一个爆料现场。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '严格审核',
    desc: '专业编辑团队多重审核机制，确保911吃瓜黑料网站内容真实可靠，杜绝虚假信息传播。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              为什么选择 <span className="text-primary-500">911爆料网</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              四大核心优势，打造全网最强吃瓜黑料内容聚合入口
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-6 md:p-7 hover:bg-background-100 transition-colors duration-200 group cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}